import { render, staticRenderFns } from "./DetailInvoice.vue?vue&type=template&id=d871c68c&"
import script from "./DetailInvoice.vue?vue&type=script&lang=js&"
export * from "./DetailInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DetailInvoice.vue?vue&type=style&index=0&id=d871c68c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports